import React from 'react';
import {createRoot} from 'react-dom/client';
import {Provider} from 'react-redux';
import {Gatekeeper} from 'gatekeeper-client-sdk';
import App from '@app/App';
import store from '@store/store';

import './utils/i18n';
import './index.css';
import * as serviceWorker from './serviceWorker';

//datatables options
import 'datatables.net-dt/css/jquery.dataTables.min.css';
// import "admin-lte/plugins/datatables-bs4/css/dataTables.bootstrap4.min.css";
import "admin-lte/plugins/datatables/jquery.dataTables.min.js";

import 'admin-lte/plugins/datatables-fixedcolumns/css/fixedColumns.bootstrap4.min.css';
import 'admin-lte/plugins/datatables-fixedcolumns/js/dataTables.fixedColumns.min.js';

// import 'admin-lte/plugins/datatables-buttons/css/buttons.bootstrap4.min.css';
import 'datatables.net-buttons-dt/css/buttons.dataTables.css';
import 'admin-lte/plugins/datatables-buttons/js/dataTables.buttons.min.js';

import 'admin-lte/plugins/datatables-buttons/js/buttons.html5.min.js';

declare const window: any;

window.PF = {
  config: {
    mode: 'bs4'
  }
};

Gatekeeper.initialize('08401b7e-da7e-4bf3-a9bf-6f594ae5fb02');

const container: any = document.getElementById('root');
const root = createRoot(container);
root.render(
  <Provider store={store}>
    <App />
  </Provider>
);

const loader = document.getElementById('global-loader');
if (loader) loader.remove();

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
